module.exports = __webpack_public_path__ + "img/service_img13.0bf62314.png";